/* KL mega menu 04.11.2026: B (komputer, kaskada 3 kolumny) + A (telefon, ekran po ekranie).
   Bez zaleznosci, delegacja zdarzen na document (naglowek bywa podmieniany przez Section Rendering API).
   Komputer: najechanie/fokus na kolumnie 1 -> grupa, na kolumnie 2 -> kolumna 3 (bestsellery z
   <kolekcja>?section_id=kl-mmk-produkty, pamiec podreczna) albo kafel konfiguratora. Menu-aim: ruch kursora
   w strone nastepnej kolumny nie przelacza pozycji, nad ktorymi kursor tylko przelatuje.
   Klawiatura: strzalki gora/dol w kolumnie, w prawo = pierwsza pozycja nastepnej kolumny, w lewo = powrot. */
(() => {
  if (window.__klMmk) return;
  window.__klMmk = true;

  const cache = new Map();
  const WIDEO = {
    mp4: 'https://cdn.shopify.com/videos/c/vp/fb0a11df7bba4552a09b0fb0ecb6965c/fb0a11df7bba4552a09b0fb0ecb6965c.SD-480p-0.9Mbps-99319819.mp4',
    plakat: 'https://cdn.shopify.com/s/files/1/0903/6477/2700/files/preview_images/fb0a11df7bba4552a09b0fb0ecb6965c.thumbnail.0000000000.jpg?v=1793278359&width=540',
    strona: '/pages/skompletuj-lampe-cameleon',
  };
  // bez wideo: ekrany dotykowe (telefon, tablet) i "ogranicz ruch" - wtedy zwykly kafel konfiguratora
  const BEZ_WIDEO = matchMedia('(hover: none), (prefers-reduced-motion: reduce)').matches;

  // wideo gra tylko przy otwartym panelu (atrybut aria-expanded na pozycji 1. poziomu ustawia motyw)
  function otwarty(panel) {
    return panel.closest('.menu-list__list-item')?.querySelector('.menu-list__link')?.getAttribute('aria-expanded') === 'true';
  }
  function graj(panel) {
    const v = panel.querySelector('.kl-mmk__v');
    if (!v) return;
    if (otwarty(panel)) v.play().catch(() => {}); else v.pause();
  }
  new MutationObserver((lista) => {
    lista.forEach((m) => {
      const li = m.target.closest?.('.menu-list__list-item');
      const panel = li?.querySelector('[data-kl-mmk]');
      if (panel) graj(panel);
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['aria-expanded'] });
  const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function pobierz(u) {
    if (!u) return Promise.resolve('');
    const url = u.split('#')[0] + (u.includes('?') ? '&' : '?') + 'section_id=kl-mmk-produkty';
    if (!cache.has(url)) {
      cache.set(url, fetch(url, { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.text() : ''))
        .then((h) => { const t = document.createElement('template'); t.innerHTML = h; const b = t.content.querySelector('.kl-mmk__prod'); return b ? b.outerHTML : ''; })
        .catch(() => { cache.delete(url); return ''; }));
    }
    return cache.get(url);
  }

  function rysuj(panel, el) {
    const c3 = panel.querySelector('[data-c3]');
    if (!c3 || !el) return;
    if (c3.__el === el) return;
    c3.__el = el;
    const d = el.dataset;
    if ('klTile' in d && /skompletuj-lampe-cameleon/.test(d.klU || '') && !BEZ_WIDEO) {
      // Cameleon: animacja konfiguratora zamiast bestsellerow (Shopify Files: kl-cameleon-konfigurator-v2.mp4, wersja 480p, plakat)
      c3.innerHTML = `<div class="kl-mmk__vid"><video class="kl-mmk__v" muted loop playsinline preload="none" width="270" height="480" ` +
        `poster="${WIDEO.plakat}" aria-label="Jak działa konfigurator CAMELEON"><source src="${WIDEO.mp4}" type="video/mp4"></video>` +
        `<div class="kl-mmk__vtx"><span class="kl-mmk__lbl">Konfigurator</span><span class="kl-mmk__tt">Skompletuj lampę CAMELEON</span>` +
        `<span class="kl-mmk__td">${esc(d.klD)}</span>` +
        `<a class="kl-mmk__btn" href="${esc(WIDEO.strona)}">Skompletuj lampę →</a></div></div>`;
      graj(panel);
      return;
    }
    if ('klTile' in d) {
      c3.innerHTML = `<a class="kl-mmk__tile" href="${esc(d.klU)}"><span class="kl-mmk__lbl">Konfigurator</span>` +
        `<span class="kl-mmk__tt">${esc(d.klT)}</span><span class="kl-mmk__td">${esc(d.klD)}</span>` +
        `<span class="kl-mmk__tc">Zacznij →</span></a>` +
        (d.klUa ? `<a class="kl-mmk__btn" href="${esc(d.klUa)}">${esc(d.klAll)} →</a>` : '');
      return;
    }
    if (!d.klU) { c3.innerHTML = ''; return; }
    // 3. kolumna = podkolekcje kategorii z menu zakladki mm-* (etykieta^url^liczba~...); bez podkolekcji = bestsellery
    const pk = (d.klPk || '').split('~').filter(Boolean).map((x) => x.split('^'));
    if (pk.length) {
      c3.innerHTML = `<div class="kl-mmk__l3w"><p class="kl-mmk__lbl">${esc(d.klT)}</p><ul class="kl-mmk__l3" role="list">` +
        pk.map(([t, u, n]) => `<li><a class="kl-mmk__it kl-mmk__it--3" href="${esc(u)}"><span class="kl-mmk__nm">${esc(t)}</span>` +
          `<span class="kl-mmk__nn">${esc(n || '')}</span></a></li>`).join('') +
        `</ul><a class="kl-mmk__all" href="${esc(d.klU)}">${esc(d.klAll)}<span class="kl-mmk__nw"> →</span></a></div>`;
      return;
    }
    // jak na planszach B: "Najczesciej kupowane" nad nazwa; w Markach nazwa marki nad nazwa i podpis nad produktami
    const marka = d.klM || '';
    c3.innerHTML = `<div class="kl-mmk__h"><div><p class="kl-mmk__lbl">${esc(marka || 'Najczęściej kupowane')}</p><p class="kl-mmk__tt">${esc(d.klT)}</p></div>` +
      `<span class="kl-mmk__cnt">${esc(d.klN)}</span></div>` + (marka ? `<p class="kl-mmk__lab">Najczęściej kupowane w marce ${esc(marka)}</p>` : '') +
      `<div class="kl-mmk__prod" aria-busy="true"><span class="kl-mmk__sk"></span><span class="kl-mmk__sk"></span><span class="kl-mmk__sk"></span></div>` +
      `<a class="kl-mmk__btn" href="${esc(d.klU)}">${esc(d.klAll)} →</a>`;
    pobierz(d.klU).then((html) => {
      if (c3.__el !== el) return;
      const box = c3.querySelector('.kl-mmk__prod');
      if (!box) return;
      if (html) box.outerHTML = html; else { box.remove(); c3.querySelector('.kl-mmk__lab')?.remove(); }
    });
  }

  function aktywuj2(panel, a) {
    if (!a) return;
    const g = a.closest('[data-g]');
    g?.querySelectorAll('[data-c2].is-on').forEach((x) => x !== a && x.classList.remove('is-on'));
    a.classList.add('is-on');
    rysuj(panel, a);
  }

  function aktywuj1(panel, a) {
    const g = a.closest('[data-g]');
    if (!g) return;
    if (!g.classList.contains('is-on')) {
      panel.querySelectorAll('[data-g].is-on').forEach((x) => x.classList.remove('is-on'));
      g.classList.add('is-on');
    }
    const c2 = g.querySelector('[data-c2].is-on') || g.querySelector('[data-c2]');
    if (c2) aktywuj2(panel, c2); else rysuj(panel, a);
  }

  function start(panel) {
    if (!panel || panel.__start) return;
    panel.__start = true;
    const g = panel.querySelector('[data-g].is-on [data-c1]') || panel.querySelector('[data-c1]');
    if (g) aktywuj1(panel, g);
  }

  /* ---- menu-aim ---- */
  let ruch = [];
  let czasomierz = 0;
  document.addEventListener('pointermove', (e) => {
    if (e.pointerType !== 'mouse' || !e.target.closest?.('[data-kl-mmk]')) { ruch = []; return; }
    ruch.push([e.clientX, e.clientY, e.timeStamp]);
    if (ruch.length > 4) ruch.shift();
  }, { passive: true });

  // tylko ruch z ostatnich 100 ms (po pauzie kursora historia od nowa - pulapka z LV 23.10)
  function swiezy() {
    const teraz = ruch.length ? ruch[ruch.length - 1][2] : 0;
    const r = ruch.filter((p) => teraz - p[2] <= 100);
    return r.length >= 2 ? [r[0], r[r.length - 1]] : null;
  }

  function wKierunku(kol) {
    // czy kursor zmierza w prawo, do kolumny obok (trojkat: punkt sprzed chwili -> gorny/dolny rog prawej krawedzi kolumny)
    const sw = swiezy();
    if (!sw || !kol) return false;
    const [[x0, y0], [x1, y1]] = sw;
    if (x1 - x0 <= 0) return false;
    const r = kol.getBoundingClientRect();
    const dx = r.right - x0;
    if (dx <= 0) return false;
    const s = (y1 - y0) / (x1 - x0);
    return s > (r.top - 60 - y0) / dx && s < (r.bottom + 60 - y0) / dx;
  }

  function wStroneKolumny(el) {
    const kol = el.closest('[data-g]')?.parentElement?.closest('.kl-mmk__c1, .kl-mmk__c2');
    if (!kol) return false;
    return wKierunku(kol);
  }


  function nad(el, fn) {
    clearTimeout(czasomierz);
    if (wStroneKolumny(el)) {
      czasomierz = setTimeout(() => { if (el.matches(':hover')) fn(); }, 160);
    } else fn();
  }

  document.addEventListener('pointerover', (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;
    const li = t.closest('.menu-list__list-item');
    if (li && !t.closest('[data-kl-mmk]')) { start(li.querySelector('[data-kl-mmk]')); return; }
    const panel = t.closest('[data-kl-mmk]');
    if (!panel) return;
    start(panel);
    // pointerover przychodzi przed pointermove w tym samym punkcie - dopisz biezaca pozycje do historii ruchu
    if (e.pointerType === 'mouse') { ruch.push([e.clientX, e.clientY, e.timeStamp]); if (ruch.length > 5) ruch.shift(); }
    const c1 = t.closest('[data-c1]');
    if (c1) {
      const aktywny = c1.closest('[data-g]')?.classList.contains('is-on');
      if (!aktywny) {
        // pozycja z wlasnym panelem kolumny 2 - menu-aim liczony wzgledem kolumny 1
        const g = c1.closest('[data-g]');
        nad(g.querySelector('[data-c1]'), () => aktywuj1(panel, c1));
      } else if (!c1.closest('[data-g]').querySelector('[data-c2]')) {
        aktywuj1(panel, c1);
      }
      return;
    }
    const c2 = t.closest('[data-c2]');
    if (c2 && !c2.classList.contains('is-on')) {
      clearTimeout(czasomierz);
      if (wKierunku(c2.closest('.kl-mmk__c2'))) {
        czasomierz = setTimeout(() => { if (c2.matches(':hover')) aktywuj2(panel, c2); }, 160);
        return;
      }
      aktywuj2(panel, c2);
    }
  });

  document.addEventListener('focusin', (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;
    const li = t.closest('.menu-list__list-item');
    if (li && t.matches('.menu-list__link')) { start(li.querySelector('[data-kl-mmk]')); return; }
    const panel = t.closest('[data-kl-mmk]');
    if (!panel) return;
    start(panel);
    if (t.matches('[data-c1]')) aktywuj1(panel, t);
    else if (t.matches('[data-c2]')) aktywuj2(panel, t);
  });

  document.addEventListener('keydown', (e) => {
    const t = e.target;
    if (!(t instanceof Element) || !t.matches('[data-c1], [data-c2]')) return;
    const panel = t.closest('[data-kl-mmk]');
    const jest1 = t.matches('[data-c1]');
    const lista = jest1 ? [...panel.querySelectorAll('[data-c1]')] : [...t.closest('.kl-mmk__l2').querySelectorAll('[data-c2]')];
    const i = lista.indexOf(t);
    let cel = null;
    if (e.key === 'ArrowDown') cel = lista[i + 1] || lista[0];
    else if (e.key === 'ArrowUp') cel = lista[i - 1] || lista[lista.length - 1];
    else if (e.key === 'ArrowRight') cel = jest1 ? t.closest('[data-g]').querySelector('[data-c2]') : panel.querySelector('[data-c3] a');
    else if (e.key === 'ArrowLeft' && t.closest('[data-c3]')) cel = panel.querySelector('[data-c2].is-on');
    else if (e.key === 'ArrowLeft' && !jest1) cel = t.closest('[data-g]').querySelector('[data-c1]');
    else return;
    if (cel) { e.preventDefault(); cel.focus(); }
  });

  /* ---- telefon: ekran 3. poziomu ---- */
  function zamknij3(s3, fokus) {
    if (!s3 || !s3.classList.contains('is-open')) return;
    s3.classList.remove('is-open');
    const btn = document.querySelector(`[data-mma-open="${s3.id}"]`);
    btn?.setAttribute('aria-expanded', 'false');
    (s3.parentElement?.closest('.kl-mma__s3') || s3.closest('.menu-drawer__submenu'))?.classList.remove('kl-mma-otwarty');
    setTimeout(() => { if (!s3.classList.contains('is-open')) s3.hidden = true; }, 260);
    if (fokus) btn?.focus();
  }

  document.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    const otw = t.closest('[data-mma-open]');
    if (otw) {
      const s3 = document.getElementById(otw.getAttribute('data-mma-open'));
      if (!s3) return;
      const sub = otw.closest('.kl-mma__s3') || otw.closest('.menu-drawer__submenu');
      if (sub) { sub.scrollTop = 0; sub.classList.add('kl-mma-otwarty'); }
      s3.hidden = false;
      void s3.offsetWidth;
      s3.classList.add('is-open');
      otw.setAttribute('aria-expanded', 'true');
      setTimeout(() => s3.querySelector('[data-mma-back]')?.focus({ preventScroll: true }), 30);
      return;
    }
    const wstecz = t.closest('[data-mma-back]');
    if (wstecz) { zamknij3(wstecz.closest('.kl-mma__s3'), true); return; }
    const x = t.closest('[data-mma-x]');
    if (x) {
      const s3 = x.closest('.kl-mma__s3');
      zamknij3(s3, false);
      const hd = x.closest('header-drawer');
      if (hd && typeof hd.close === 'function') hd.close();
      else hd?.querySelector('.menu-drawer__close-button')?.click();
      return;
    }
    // powrot/zamkniecie szuflady motywu: chowamy otwarte ekrany 3. poziomu
    if (t.closest('.menu-drawer__back-button, .menu-drawer__close-button, .header__icon--menu')) {
      document.querySelectorAll('.kl-mma__s3.is-open').forEach((s) => zamknij3(s, false));
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const otwarte = document.querySelectorAll('.kl-mma__s3.is-open');
    const s3 = otwarte[otwarte.length - 1];
    if (s3) { e.stopPropagation(); zamknij3(s3, true); }
  }, true);
})();
